module.exports = __webpack_public_path__ + "img/C9.4aa78405.png";